import { useMutation } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

interface DownloadCertificatePayload {
  vesselId: string
  filename: string
  versionId?: string
}

interface DownloadCertificateResponse {
  signedUrl: string
}

export function useDownloadCertificate() {
  const fetchRequest = useFetch()

  return useMutation<
    DownloadCertificateResponse,
    Error,
    DownloadCertificatePayload
  >({
    mutationFn: ({ vesselId, filename, versionId }) =>
      fetchRequest(
        `${apiBase()}/vessels/${vesselId}/file?name=${encodeURIComponent(filename)}&attachment=true${
          versionId ? `&versionId=${encodeURIComponent(versionId)}` : ''
        }`,
      ) as Promise<DownloadCertificateResponse>,
  })
}
